import { ProductLevel } from '../types/products';
import { useHighestProductLevelDFC } from './highestProductLevel';
export const useIsPaidPortal = () => {
  const {
    data,
    loading: highestProductLevelLoading
  } = useHighestProductLevelDFC();
  return [!!(data !== null && data !== void 0 && data.highestProductLevel && data.highestProductLevel !== ProductLevel.NONE), highestProductLevelLoading];
};